import type { CSSProperties } from "react";

export const CHECKOUT_THEME = {
  pageBackground: "#3f4042",
  textPrimary: "#ffffff",
  borderColor: "#a300e5",
  gradientStart: "#6e0d8f",
  gradientEnd: "#560368",
  qrCornerColor: "#ffaf08",
  successBg: "#32b546",
  successRing: "rgba(186, 236, 193, 0.85)",
  failedBg: "#ff3f46",
  failedRing: "rgba(255, 194, 197, 0.85)",
  loadingBackground: "#5b0a78",
  loadingBorder: "#9650bb",
  errorText: "#ffd5da",
  modalRadius: "28px",
  titleFontSize: "60px",
  subtitleFontSize: "52px",
} as const;

export const CHECKOUT_THEME_VARS: CSSProperties = {
  ["--ep-page-bg" as "--ep-page-bg"]: CHECKOUT_THEME.pageBackground,
  ["--ep-text-primary" as "--ep-text-primary"]: CHECKOUT_THEME.textPrimary,
  ["--ep-border-color" as "--ep-border-color"]: CHECKOUT_THEME.borderColor,
  ["--ep-grad-start" as "--ep-grad-start"]: CHECKOUT_THEME.gradientStart,
  ["--ep-grad-end" as "--ep-grad-end"]: CHECKOUT_THEME.gradientEnd,
  ["--ep-qr-corner" as "--ep-qr-corner"]: CHECKOUT_THEME.qrCornerColor,
  ["--ep-success-bg" as "--ep-success-bg"]: CHECKOUT_THEME.successBg,
  ["--ep-success-ring" as "--ep-success-ring"]: CHECKOUT_THEME.successRing,
  ["--ep-failed-bg" as "--ep-failed-bg"]: CHECKOUT_THEME.failedBg,
  ["--ep-failed-ring" as "--ep-failed-ring"]: CHECKOUT_THEME.failedRing,
  ["--ep-load-bg" as "--ep-load-bg"]: CHECKOUT_THEME.loadingBackground,
  ["--ep-load-border" as "--ep-load-border"]: CHECKOUT_THEME.loadingBorder,
  ["--ep-error-text" as "--ep-error-text"]: CHECKOUT_THEME.errorText,
  ["--ep-modal-radius" as "--ep-modal-radius"]: CHECKOUT_THEME.modalRadius,
  ["--ep-title-size" as "--ep-title-size"]: CHECKOUT_THEME.titleFontSize,
  ["--ep-subtitle-size" as "--ep-subtitle-size"]: CHECKOUT_THEME.subtitleFontSize,
};
